import React from 'react'

function Footer() {
  return (
    <>
    <hr/>
    <div className='container mt-5 '>
        <div className=' col-md-12 d-flex justify-content-between'>
        <div className='col-md-3 d-flex justify-content-around'>
       <h5 className=''>Omega</h5>
       <p>  2020 UX Theme, All Right Reserved</p>
       </div>
       <div className='col-md-4 d-flex justify-content-around'>
            <p>Support</p>
            <p>Privacy Policy</p>
            <p>Terms and Conditions</p>
        </div>
        </div>
        
    </div>

    </>
  )
}

export default Footer